import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=8d0daa3c&scoped=true&"
import script from "./Channels.vue?vue&type=script&lang=ts&"
export * from "./Channels.vue?vue&type=script&lang=ts&"
import style0 from "./Channels.vue?vue&type=style&index=0&id=8d0daa3c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0daa3c",
  null
  
)

export default component.exports